import { TranslationResource } from './TranslationResource';
export var getTranslateFn = function (translateFn) {
    return function (key) {
        var translation = translateFn === null || translateFn === void 0 ? void 0 : translateFn(key);
        if (!translation || translation === key) {
            translation = TranslationResource[key] || key;
        }
        return translation;
    };
};
//# sourceMappingURL=translation.js.map